{
  "arbre": "Estructura organitzativa",
  "nouDepartament": "Nou departament",
  "cerca": "Cerca departament, àrea o servei…",
  "filtres": {
    "etiqueta": "Tipus d'àrea",
    "tot": "Tot",
    "GUARDIA_IT": "Guàrdia",
    "CRISI": "Crisi"
  },
  "mostraInactius": "Mostra inactius",
  "nNivells_one": "{{count}} nivell",
  "nNivells_other": "{{count}} nivells",
  "compteDep": "{{arees}} · {{serveis}}",
  "senseFiltre": "Cap àrea coincideix amb el filtre.",
  "llegenda": "Ratllat = inactiu",
  "afegeixFill": "Afegeix {{tipus}} a {{nom}}",
  "plega": "Plega {{nom}}",
  "desplega": "Desplega {{nom}}",
  "tipus": {
    "DEPARTAMENT": "departament",
    "AREA": "àrea",
    "SERVEI": "servei"
  },
  "tipusCap": {
    "DEPARTAMENT": "Departament",
    "AREA": "Àrea",
    "SERVEI": "Servei"
  },
  "inactiu": "Inactiu",
  "senseResultats": "Res no coincideix amb «{{q}}»",
  "buit": "Encara no hi ha cap departament. Crea'n el primer.",
  "tria": "Tria un departament, una àrea o un servei de l'arbre.",
  "organitzacio": "Organització",
  "accions": {
    "desactiva": "Desactiva",
    "reactiva": "Reactiva",
    "mou": "Mou…",
    "nou": {
      "AREA": "Nova àrea",
      "SERVEI": "Nou servei"
    }
  },
  "dades": {
    "DEPARTAMENT": "Dades del departament",
    "AREA": "Dades de l'àrea",
    "SERVEI": "Dades del servei"
  },
  "camps": {
    "nom": "Nom",
    "codi": "Codi",
    "codiAjuda": "Identificador curt i únic.",
    "tipusArea": "Tipus d'àrea",
    "descripcio": "Descripció",
    "procediment": "Procediment alternatiu",
    "procedimentAjuda": "El veuran les persones que rebin l'avís si el servei no està disponible.",
    "circuit": "Circuit d'escalat",
    "circuitDefecte": "Circuit per defecte",
    "veuCircuit": "Mostra el circuit",
    "plantilla": "Plantilla de missatge",
    "sensePlantilla": "Sense plantilla",
    "canals": "Canals per defecte",
    "canalsAjuda": "Canals amb què s'avisa per defecte en activar aquest servei. Només es canvien aquí."
  },
  "ajudaTipus": {
    "GUARDIA_IT": "Té calendari de guàrdies i tècnic de guàrdia.",
    "CRISI": "Avisa el comitè; la guàrdia és opcional."
  },
  "fills": {
    "AREA": "Àrees de {{nom}}",
    "SERVEI": "Serveis de {{nom}}"
  },
  "senseFills": {
    "AREA": "Aquest departament encara no té àrees.",
    "SERVEI": "Aquesta àrea encara no té serveis."
  },
  "nArees_one": "{{count}} àrea",
  "nArees_other": "{{count}} àrees",
  "nServeis_one": "{{count}} servei",
  "nServeis_other": "{{count}} serveis",
  "guardia": {
    "titol": "De guàrdia ara",
    "calendari": "Calendari",
    "calendaris": "Calendaris",
    "titular": "Titular",
    "suplent": "Suplent",
    "fins": "fins {{data}}",
    "senseSuplent": "Sense suplent",
    "senseCobertura": "Sense cobertura ara",
    "ningu": "Ningú de guàrdia ara",
    "ninguText": "Els avisos dels seus serveis escalaran directament al nivell següent del circuit.",
    "crisi": "Àrea de crisi: els avisos van al comitè. La guàrdia és opcional i ara no n'hi ha cap.",
    "crisiFila": "Àrea de crisi: sense guàrdia assignada",
    "cobreix_one": "Cobreix el servei de l'àrea",
    "cobreix_other": "Cobreix els {{count}} serveis de l'àrea",
    "departament": "Guàrdia del departament",
    "departamentText": "Rep els avisos que escalen per sobre de l'àrea",
    "senseDepartament": "Aquest departament no té guàrdia de departament ara.",
    "totesCobertes": "Totes les àrees cobertes",
    "areesSense_one": "{{count}} àrea sense cobertura",
    "areesSense_other": "{{count}} àrees sense cobertura",
    "area": "Àrea",
    "senseArees": "Aquest departament no té àrees.",
    "carregant": "Carregant les guàrdies…",
    "senseDades": "No s'han pogut consultar les guàrdies.",
    "servei": "Guàrdia de l'àrea",
    "serveiText": "El tècnic de guàrdia de l'àrea {{area}} cobreix aquest servei."
  },
  "pestanyes": {
    "etiqueta": "Seccions del servei",
    "general": "General",
    "avisos": "Avisos",
    "persones": "Persones",
    "documents": "Documents"
  },
  "experts": {
    "titol": "Experts",
    "buit": "Aquest servei no té experts assignats.",
    "gestiona": "Gestiona",
    "TITULAR": "Titular",
    "SUBSTITUT": "Substitut"
  },
  "documents": {
    "titol": "Documents del servei",
    "buit": "Aquest servei encara no té documents.",
    "puja": "Puja un document per a aquest servei",
    "biblioteca": "Obre la biblioteca",
    "versio": "v{{n}}"
  },
  "crea": {
    "etiqueta": {
      "DEPARTAMENT": "Nou departament",
      "AREA": "Nova àrea",
      "SERVEI": "Nou servei"
    },
    "titol": {
      "DEPARTAMENT": "Crea un departament",
      "AREA": "Crea una àrea",
      "SERVEI": "Crea un servei"
    },
    "boto": {
      "DEPARTAMENT": "Crea el departament",
      "AREA": "Crea l'àrea",
      "SERVEI": "Crea el servei"
    },
    "placeholder": {
      "DEPARTAMENT": "p. ex. Recursos Humans",
      "AREA": "p. ex. Seguretat informàtica",
      "SERVEI": "p. ex. Wifi de botigues"
    },
    "on": "Es crearà a:",
    "arrel": "Organització (nivell superior)",
    "codiSuggerit": "Si el deixes buit, serà {{codi}}. No es podrà canviar fàcilment.",
    "hereta": "Hereta el tipus {{tipus}} de l'àrea. Després podràs assignar-hi circuit, plantilla i persones a les seves pestanyes.",
    "cancella": "Cancel·la"
  },
  "confirma": {
    "desactivaTitol": "Desactiva «{{nom}}»",
    "reactivaTitol": "Reactiva «{{nom}}»",
    "desactivaText": "Deixarà d'aparèixer en crear activacions i als selectors. L'historial es conserva i es pot reactivar.",
    "desactivaFills": "Els seus elements continuaran existint, però no es podran triar mentre estigui inactiu.",
    "reactivaText": "Tornarà a estar disponible per a noves activacions.",
    "desactiva": "Desactiva",
    "reactiva": "Reactiva"
  },
  "mou": {
    "titol": "Mou «{{nom}}»",
    "etiqueta": "Moure",
    "AREA": "Departament de destí",
    "SERVEI": "Àrea de destí",
    "ara": "Ara és a:",
    "text": "Es mourà amb tot el que conté. Els rols assignats al lloc d'origen deixaran d'aplicar-s'hi.",
    "mou": "Mou"
  },
  "informar": {
    "titol": "Persones a informar",
    "resum_one": "{{count}} persona",
    "resum_other": "{{count}} persones",
    "afegeix": "Afegeix persona",
    "edita": "Edita",
    "editaPersona": "Edita {{nom}}",
    "editaTitol": "Edita «{{nom}}»",
    "nouTitol": "Nova persona a informar",
    "etiqueta": "Persona a informar",
    "importa": "Importa Excel",
    "exporta": "Exporta",
    "cerca": "Cerca a la llista…",
    "buit": "Aquest servei no té persones a informar.",
    "senseCoincidencies": "Ningú de la llista coincideix amb la cerca.",
    "senseCompte": "Sense compte",
    "senseCompteAjuda": "No té compte corporatiu: només rep avisos pels canals amb telèfon o correu.",
    "treu": "Treu",
    "treuPersona": "Treu {{nom}}",
    "treuTitol": "Treu «{{nom}}» de la llista",
    "treuText": "Deixarà de rebre els avisos d'aquest servei.",
    "correuInvalid": "Cal un correu electrònic vàlid.",
    "canalsBuit": "Tria com a mínim un canal.",
    "origenEntra": "Les dades venen d'Entra ID: aquí només pots canviar els canals.",
    "origenUsuari": "És un usuari de l'aplicació: aquí només pots canviar els canals.",
    "usuari": "Usuari",
    "cercaUsuari": "Cerca un usuari per nom o correu",
    "cercaUsuariAjuda": "Escriu com a mínim 2 lletres per cercar entre els usuaris de l'aplicació.",
    "senseUsuaris": "Cap usuari coincideix amb la cerca.",
    "canviaUsuari": "Canvia",
    "desa": "Desa",
    "crea": "Afegeix a la llista",
    "nom": "Nom",
    "contacte": "Contacte",
    "email": "Correu electrònic",
    "telefon": "Telèfon",
    "canals": "Canals",
    "origen": "Origen",
    "origens": {
      "MANUAL": "Manual",
      "ENTRA": "Entra ID",
      "EXCEL": "Excel"
    }
  }
}
